<template>
  <div>
    <div class="row">
      <div class="col s12 m6">
        <pay-setting-switch
          :gid="gid"
          label="Use Default Integrations Portal Settings:"
          setting-field="useDefaultIntegrationsPortalSettings"
          :initial-state="defaultIntegrationsPortalSettings"
          mutation-attribute="useDefaultIntegrationsPortalSettings"
          v-model="useDefaultIntegrationsPortalSettingsState"
          >
        </pay-setting-switch>
      </div>
      <div class="col s12 m6" v-show="!useDefaultIntegrationsPortalSettingsState">
        <pay-setting-switch
          :gid="gid"
          label="Allow Integrations Portal:"
          setting-field="allowIntegrationsPortal"
          :initial-state="allowIntegrationsPortal"
          mutation-attribute="allowIntegrationsPortal"
          >
        </pay-setting-switch>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['gid', 'defaultIntegrationsPortalSettings', 'allowIntegrationsPortal'],
  data() {
    return {
      useDefaultIntegrationsPortalSettingsState: this.defaultIntegrationsPortalSettings
    }
  }
}
</script>
